import React from 'react';
import { withRouter} from 'react-router-dom';
import { Link } from 'react-router-dom';
/*** styles ***/
import './style.css';

const  StepStatus= (props) => {
    /*** current step from url
     * step 1 it is general setup (length, width, deckel, boden and etc.)
     * step 2 side A
     * step 3 side B
     * step 4 side C
     * step 5 side D
     * step 6 finish step
     * it is possible to pass here some custom header
     * is in props.isFinish === true then will finishHeader
     * ***/
    const step = props.match.url.split("/")[props.match.url.split("/").length -1],
          /*** PAGES NAMES ***/
          sides = ["", " - ANSICHT A", " - ANSICHT B", " - ANSICHT C", " - ANSICHT D"],
          finishHeader = "LETZTER SCHRITT - KONTROLLE & SENDEN",
          statusHeader = props.header || `GRUNDRISS ${sides[step - 1]}`,
          header = props.isFinish ? finishHeader : statusHeader;
    return (
        <div className="step-status">
            <h1 className={"header"}>{header}</h1>
            <div style = {{display:"inline-block"}}>Schritt {step} von 6</div>

            {props.isDirect ?
                <div   style={{display: "inline-block", paddingLeft : "20px"}}>
                    <Link to = "/step/6"  className={"direct-to-finish"}>
                        direkt zur Kontrolle >>
                    </Link>
                </div>
                : null
            }
            {props.withoutHint || step != 1
              ? null
              :  <p> Bitte die Masse in 5cm Abständen eingeben.</p>}
        </div>
    )
};

export default withRouter(StepStatus)


// WEBPACK FOOTER //
// ./src/components/CarentPageComponents/StepStatus.js